import { render, staticRenderFns } from "./FormularioTipoServico.vue?vue&type=template&id=71f4dd88&scoped=true&"
import script from "./FormularioTipoServico.vue?vue&type=script&lang=ts&"
export * from "./FormularioTipoServico.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioTipoServico.vue?vue&type=style&index=0&id=71f4dd88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4dd88",
  null
  
)

export default component.exports